import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../utils';
import { Country } from 'country-state-city';

const getFlagUrl = (countryCode) => {
    return `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
};

const StatsList = ({ filters }) => {
    const chartContainerRef = useRef(null);

    const [players, setPlayers] = useState([]);

    const [topPlayers, setTopPlayers] = useState([]);

    const [countryMapping, setCountryMapping] = useState({});

    const [currentPage, setCurrentPage] = useState(1);

    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {

        const fetchPlayers = async (page = currentPage) => {

            const url = new URL(`${process.env.REACT_APP_RANKINGS_USERS_LIST}`);

            url.searchParams.set('page', currentPage);

            url.searchParams.set('limit', 15)

            if (filters.country) url.searchParams.set('country', filters.country);

            if (filters.state) url.searchParams.set('state', filters.state);

            if (filters.game) url.searchParams.set('type', filters.game);

            if (filters.search) url.searchParams.set('search', filters.search);

            if (filters.sort) url.searchParams.set('sort', filters.sort);

            const response = await axios.get(url.toString());

            const data = response.data.data.list;

            const isFilterApplied = filters.country || filters.state || filters.game || filters.search;

            setPlayers(data);
            setCurrentPage(response.data.data.pagination.currentPage);
            setTotalPages(response.data.data.pagination.totalPages);

            const sortedTopPlayers = [...data].sort((a, b) => a.position - b.position).slice(0, 6);
            if (page === 1) {
                if (!isFilterApplied) {
                    setTopPlayers(sortedTopPlayers);
                } else {
                    setTopPlayers(data);
                }
            }
        }
        fetchPlayers()
    }, [currentPage, filters])

    useEffect(() => {
        const countryList = Country.getAllCountries();
        const mapping = countryList.reduce((acc, country) => {
            acc[country.name] = country.isoCode;
            return acc;
        }, {});
        setCountryMapping(mapping);
    }, []);


    useEffect(() => {
        if (chartContainerRef.current && topPlayers.length) {
            const chart = new window.CanvasJS.Chart(chartContainerRef.current, {
                backgroundColor: "#212121",
                axisY: {
                    tickThickness: 0,
                    labelFontColor: "#4d4d4d",
                    includeZero: true,
                    gridDashType: "solid",
                    gridColor: "#4d4d4d",
                    lineThickness: 0,
                    labelFontWeight: "bold",
                    labelFontSize: 14,
                    labelFontFamily: "Poppins",

                },
                toolTip: {
                    shared: true,
                    contentFormatter: function (e) {
                        var str = "";
                        for (var i = 0; i < e.entries.length; i++) {
                            var playerName = e.entries[i].dataSeries.name;
                            var value = e.entries[i].dataPoint.y;
                            str += playerName + ": " + value + "<br/>";
                        }
                        return str;
                    }
                },
                axisX: {
                    tickThickness: 0,
                    labelFontColor: "#2e5a70",
                    gridThickness: 0,
                    labelFontWeight: "bold",
                    labelFontSize: 14,
                    labelFontFamily: "Poppins"
                },
                legend: {
                    cursor: "pointer",
                    itemclick: toggleDataSeries
                },
                dataPointWidth: 40,
                data: topPlayers ? (topPlayers.map((player, index) => ({
                    type: "column",
                    color: index === 0 ? "#344bfd" :
                        index === 1 ? "#00edb1" :
                            index === 2 ? "#e75656" :
                                index === 3 ? "#f7a832" :
                                    index === 4 ? "#32f7b4" :
                                        "#b4b4b4",
                    axisYIndex: 0,
                    name: player.name,
                    dataPoints: [
                        { label: "Wins", y: player.wins },
                        { label: "Losses", y: player.losses },
                        { label: "Skunks", y: player.skunks },
                        { label: "Fouls", y: player.fouls },
                        { label: "Misses", y: player.misses },
                        { label: "Points", y: player.points },
                    ]
                }))) : []
            });
            chart.render();
        }

        function toggleDataSeries(e) {
            if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
                e.dataSeries.visible = false;
            } else {
                e.dataSeries.visible = true;
            }
            e.chart.render();
        }
    }, [topPlayers]);

    const goToPage = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };



    return (
        <>

            <div className="stats-section">
                <div className="row">
                    <div className="col-12">
                        <div className="wrapper-card">
                            <div className="top-heading-blk">
                                <div className="heading">
                                    <h2>Total Stats</h2>
                                </div>
                                <div className="side-content-blk">
                                    <div className="stats-preview-blk">
                                        {topPlayers.length > 0 ? (
                                            topPlayers.slice(0, 6).map((topPlayer, index) => {
                                                const getPointsClass = (position) => {
                                                    if (position === 1) return 'text-dark-blue';
                                                    if (position === 2) return 'text-lgt-green';
                                                    if (position === 3) return 'text-red1';
                                                    if (position === 4) return 'text-yellow';
                                                    if (position === 5) return 'text-cyan';
                                                    return 'text-gray';
                                                };
                                                return (
                                                    <div className="stats-preview-card" key={index}>
                                                        <div className="stats-preview-img">
                                                            <img src={topPlayer?.profileImage ? getImageUrl(topPlayer?.profileImage) : "/assets/images/dummy-user.png"} alt="user" />
                                                        </div>
                                                        <div className="stats-preview-detail">
                                                            <p className="stats-preview-title">{topPlayer?.name}</p>
                                                            <p className={`stats-preview-number ${getPointsClass(topPlayer?.position)}`}>{topPlayer?.points}</p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        ) : (
                                            <p>No top players to display</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="graph-blk">
                                {players.length > 0 ? (
                                    <div id="chartContainer" ref={chartContainerRef} style={{ height: 400, width: "100%" }}></div>
                                ) : (
                                    <p>No data to display</p>
                                )}
                                {/* <img src="assets/images/graph-img.png" alt="graph" /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="player-list-section spacer">
                <div className="row">
                    <div className="col-12">
                        <div className="top-heading-blk">
                            <div className="heading">
                                <h2>Players List</h2>
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Compare</th>
                                            <th><img src="assets/images/ipl-tbl-icon.png" alt="ipl icon" /></th>
                                            <th>Country</th>
                                            <th>Postiton</th>
                                            <th>Total Wins</th>
                                            <th>Total Losses</th>
                                            <th>Total Skunks</th>
                                            <th>Total fouls</th>
                                            <th>Total Misses</th>
                                            <th>Total Points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {players.map((player, index) => {
                                            const countryCode = countryMapping[player.country];
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <Link to="/player"
                                                            state={player} className="table-user-blk">
                                                            <span className="tbl-user-img">
                                                                <img src={(player?.profileImage) ? (getImageUrl(player?.profileImage)) : '/assets/images/dummy-user.png'} alt="user" />
                                                            </span>
                                                            <span className="user-name">{player.name}</span>
                                                        </Link>
                                                    </td>
                                                    <td>
                                                        <img src="assets/images/star.svg" alt="star" width="12px" height="12px" />
                                                    </td>
                                                    <td>{player.ranking}</td>
                                                    <td>
                                                        {countryCode ? (
                                                            <img src={getFlagUrl(countryCode)} alt="Flag" width="24px" height="18px" style={{ borderRadius: 3 }} />
                                                        ) : (
                                                            <img src='assets/images/global2.png' alt="global" width="28px" height="18px" style={{ borderRadius: 3 }} />
                                                        )}
                                                    </td>
                                                    <td>{player.position}</td>
                                                    <td>{player.wins}</td>
                                                    <td>{player.losses}</td>
                                                    <td>{player.skunks}</td>
                                                    <td>{player.fouls}</td>
                                                    <td>{player.misses}</td>
                                                    <td>{player.points}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-pagination">
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-center align-items-center gap-3 gap-sm-4">
                                        <li className="page-item">
                                            <span className="page-text">Page</span>
                                        </li>
                                        {currentPage > 1 && (
                                            <li className="page-item">
                                                <button className="first-page-link" onClick={() => goToPage(1)}>
                                                    1
                                                </button>
                                            </li>
                                        )}
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-arrow" onClick={goToPreviousPage} disabled={currentPage === 1}>
                                                <img src="assets/images/left-table-arrow.svg" alt="arrow" />
                                            </button>
                                        </li>
                                        <li className="page-item">
                                            <button className="page-link active" onClick={() => goToPage(currentPage)}>
                                                {currentPage}
                                            </button>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-arrow" onClick={goToNextPage} disabled={currentPage === totalPages}>
                                                <img src="assets/images/right-table-arrow.svg" alt="arrow" />
                                            </button>
                                        </li>
                                        <li className="page-item">
                                            <button className="last-page-link" onClick={() => goToPage(totalPages)}>
                                                {totalPages}
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StatsList;




